<!-- <section class="vh-100" style="background-color: #385b9b;">
  <div class="container py-5 h-100">
    <div class="row MainDiv h-100"> -->
      <!-- Login Pannel Size According To Resolution -->
      <!-- <div class="col-sm col-md-10 col-lg-9 col-xl-7 animationLogin">
        <div class="card" style="border-radius: 1rem;">
          <div class="row g-0"> -->
            <!-- Login Pannel Img -->
            <!-- <div class="col-sm col-md col-lg col-xl d-none d-md-block">
              <img src="../../../assets/Images/loginpage.webp" alt="login form" class="img-fluid ColImg"/>
            </div> -->
            <!-- Login Pannel -->
            <!-- <div class="col-sm col-md col-lg col-xl LoginPannel"> -->
              <!-- Padding Spacing In Logout PANNEL -->
              <!-- <div class="card-body p-2 p-md-3 p-lg-4 p-xl-5">
                <form *ngIf="formValue" [formGroup]="formValue" novalidate>
                  <h2 class="LoginH2"><b>Forgot Password</b></h2>
                  <div>
                    <label class="form-label text-center">
                      <b>To resend your password, provide<br> the registered email</b>
                    </label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="name" formControlName="email" placeholder="Enter Email" autocomplete="off">
                    <label for="forName">Email</label>
                  </div> -->
                  <!-- Buttons -->
                  <!-- <div class="text-center">
                    <button type="submit" class="btn btn-outline-primary" (click)="resendPassword()">
                      <b>
                        Resend Password <span class="spinner-border spinner-border-sm" *ngIf="loading" role="status" aria-hidden="true"></span>
                      </b>
                    </button> &nbsp;
                    <button type="submit" class="btn btn-outline-danger" (click)="onCancelClicked()">
                      <b>
                        Cancel
                      </b>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-2">
          <p class="cardFooter" style="color: white;"> {{copyRight}} <span> {{appVersion}}</span></p>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-- New Forgot Password Page -->
<!-- /* Try New LoginPage CSS */ -->
<section class="back-image">
  <div class="container">
    <div class="row mainDiv py-5">
      <div class="col-sm col-md-10 col-lg-9 col-xl-7 animationForContainer">
        <div class="card">
          <div class="row g-0">
            <div class="col-sm col-md col-lg col-xl d-none d-md-block">
              <img src="../../../assets/Images/login_image.jpg" alt="login form" class="img-fluid colImg"/>
            </div>
            @if (formValue) {
            <div class="col-sm col-md col-lg col-xl loginPannel animationForRightSection">
              <div class="card-body p-2 p-md-3 p-lg-4 p-xl-4">
                <form class="d-flex flex-column h-100" [formGroup]="formValue" novalidate>
                  <h6 class="loginH2">Welcome</h6>
                  <hr class="mt-0 hr-loginpage" />
                  <h4 class="loginH5">Forgot Password?</h4>
                  <div>
		                <label class="form-label login-label">To resend your password, provide the registered email id.<span class="text-danger">*</span></label>
                  </div>
                  <div class="mb-2">
                    <!-- <label class="form-label login-label">Email ID</label> -->
                    <input type="text" class="form-control input-field border-2" data-testid="email" name="userName" id="name" formControlName="email" placeholder="example@domain.com" autocomplete="off" (input)="OnInputChange()">
                    @if (forgotPasswordError) {
                      <div class="text-danger small mt-1">
                        {{forgotPasswordError}}
                      </div>
                    }
                  </div>
                  <!-- Buttons -->
                  <!-- <div class="text-center">
                    <button type="submit" class="btn btn-outline-primary" (click)="resendPassword()">
                    
                      <b>
                        Resend Password 
                        @if(loading){
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                      </b>
                    
                    </button> &nbsp;
                    <button type="submit" class="btn btn-outline-danger" (click)="onCancelClicked()">
                      <b>
                        Cancel
                      </b>
                    </button>
                  </div> -->
                  <div class="sticky-bottom-buttons">
                    <div class="row mt-4">
                      <div class="col-6">
                        <button type="reset" class="btn btn-cancel w-100 mb-4" data-testid="btn-login"(click)="onCancelClicked()" [disabled]="loading">{{loginText}}</button>        
                      </div>
                      <div class="col-6">
                        <button type="submit" class="btn btn-submit w-100 mb-4" data-testid="btn-reset"(click)="resendPassword()">Reset 
                          <!-- @if (loading) {
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          } -->
                        </button>  
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
          </div>
        </div>
        <div class="text-center mt-2">
          <p class="cardFooter copyright-text"> {{copyRight}}</p>
        </div>
      </div>
    </div>
  </div>
</section> 